import Phaser from "phaser";
import { installLetterboxFit } from "../ui/responsive";
import mapConfig from "../data/mapConfig.json";
import type { BattleReport, BattleResult } from "../../../../shared/types/BattleEvent";
import { getOrCreatePlayerId, loadBattleHistory, loadPlayerMemory, loadSettings } from "../../ai/localMemory";
import { ResultPanel } from "../../ui/ResultPanel";
import { dailyBoardKey, ENDLESS_BOARD, submitScore } from "../../net/leaderboard";
import { dailyChallengeFromSeed, dailyScore, dateKeyOf } from "../dailyChallenge";

export class ResultScene extends Phaser.Scene {
  constructor() {
    super("ResultScene");
  }

  create(data: { result?: "win" | "loss"; report?: BattleReport; battleResult?: BattleResult }) {
    installLetterboxFit(this);
    const result = data.result ?? "loss";
    const battleResult = data.battleResult ?? loadBattleHistory().at(-1)?.result;
    this.add.image(640, 360, mapConfig.mapAssetKey).setDisplaySize(1280, 720);
    this.add.rectangle(640, 360, 1280, 720, 0x08070a, 0.54);
    new ResultPanel(this, data.report, result, loadSettings().language, battleResult, {
      canReplay: Boolean(battleResult?.events?.length),
      onReplay: () => this.scene.start("ReplayScene", { battleResult, report: data.report }),
      onReturn: () => this.scene.start("MenuScene")
    });
    this.submitToLeaderboard(result, battleResult);
  }

  /** Fire-and-forget global leaderboard submit for daily/endless runs (no-op if unconfigured). */
  private submitToLeaderboard(result: "win" | "loss", battleResult?: BattleResult) {
    if (!battleResult) return;
    const playerId = getOrCreatePlayerId();
    const name = loadPlayerMemory(playerId).nickname ?? "Commander";
    if (battleResult.mode === "daily" && typeof battleResult.dailySeed === "number") {
      const score = dailyScore({ win: result === "win", battleTime: battleResult.battleTime, weight: dailyChallengeFromSeed(battleResult.dailySeed).weight });
      void submitScore(dailyBoardKey(dateKeyOf(new Date())), name, score, playerId);
    } else if (battleResult.mode === "endless") {
      void submitScore(ENDLESS_BOARD, name, Math.round(battleResult.battleTime), playerId);
    }
  }
}
